var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "project-card",
      style: { "border-color": _vm.project.color_hex }
    },
    [
      _c(
        "q-card-title",
        {
          staticClass: "overflow-hidden cursor-pointer",
          nativeOn: {
            click: function($event) {
              return _vm.handleViewProject($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-between items-center" }, [
            _c("div", { staticClass: "col-auto row items-center" }, [
              _c("span", { staticClass: "q-title text-bold" }, [
                _vm._v(_vm._s(_vm.project.name))
              ]),
              !_vm.project.active
                ? _c(
                    "div",
                    { staticClass: "on-right" },
                    [
                      _c(
                        "q-chip",
                        {
                          attrs: {
                            dense: "",
                            color: "warning",
                            "text-color": "white"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("archived")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _vm.isNotStarted
                  ? _c(
                      "q-chip",
                      {
                        staticClass: "faded-tag q-px-sm",
                        attrs: {
                          color: "white",
                          "text-color": "faded",
                          dense: "",
                          rounded: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("no_time_entries_badge")) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm.isSettled
                    ? _c(
                        "q-chip",
                        {
                          staticClass: "positive-tag q-px-sm",
                          attrs: {
                            icon: "check",
                            color: "white",
                            "text-color": "positive",
                            dense: "",
                            rounded: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("no_open_project_hours")) +
                              "\n        "
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "row items-center q-body-2" },
                        [
                          _c("q-icon", {
                            attrs: { name: "timer", color: "grey-6" }
                          }),
                          _c("span", { staticClass: "on-right" }, [
                            _vm._v(
                              _vm._s(_vm.openHours) +
                                " " +
                                _vm._s(_vm.$tc("open_hour", _vm.openHours))
                            )
                          ])
                        ],
                        1
                      )
              ],
              1
            )
          ])
        ]
      ),
      _c("q-card-main", { staticClass: "q-mt-md" }, [
        _c("div", { staticClass: "row gutter-y-sm gutter-x-md" }, [
          _vm.hasCustomer
            ? _c(
                "div",
                { staticClass: "col-auto row items-center" },
                [
                  _c("q-icon", {
                    attrs: { name: "business", color: "grey-6" }
                  }),
                  _c("span", { staticClass: "on-right" }, [
                    _vm._v(_vm._s(_vm.customerName))
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-auto row items-center" },
            [
              _c("q-icon", {
                attrs: { name: "calendar_today", color: "grey-6" }
              }),
              _c("span", { staticClass: "on-right" }, [
                _vm._v(_vm._s(_vm.projectDate))
              ]),
              _c(
                "q-tooltip",
                {
                  attrs: {
                    delay: 500,
                    anchor: "bottom middle",
                    self: "top middle"
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("project_start_date")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }